import { Badge } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import type { PickStatus } from './api';

/**
 * One status, one colour, wherever a pick appears.
 *
 * Same scheme as the sales order badge: grey for waiting, blue for being worked, green for done,
 * red for cancelled. Cancelled is red rather than dark because it is the one that surprises
 * somebody — a pick is cancelled when its order is closed underneath it, which happens while the
 * picker is halfway down the aisle.
 */
const COLOURS: Record<PickStatus, string> = {
  open: 'gray',
  in_progress: 'blue',
  completed: 'green',
  cancelled: 'red',
};

export function PickStatusBadge({ status }: { status: PickStatus }) {
  const { t } = useTranslation();
  return (
    <Badge color={COLOURS[status] ?? 'gray'} variant="light">
      {t(`picks.statuses.${status}`)}
    </Badge>
  );
}
